import { PublicCallback } from 'globals/types';
import { updateSatisfactionResponse } from 'core_main/api/satisfaction';
import { createSatisfactionCallbackResponse } from 'core_main/api/satisfaction/helpers';
import { importAndInitializePubNub } from 'core_main/globals/vendors';
import { getSessionFromStore, getStore } from 'core_main/store';
import { getSession } from 'core_main/api/sessions';
import { KUSTOMER_APP_CHAT_CSAT_SUBMIT_EVENT } from 'core_main/pubnub/constants';
import { handleError } from 'globals/errors';
import { SubmitSatisfactionFormParameters } from './types';

export const publishSatisfactionSubmitMessage = (message, cb) => {
  let pubnub;

  const conversationId = message.data.relationships.conversation.data.id;

  return importAndInitializePubNub()
    .then((module) => {
      pubnub = module;

      return getSessionFromStore(conversationId);
    })
    .then((sessionFromStore) => {
      if (!sessionFromStore) return getSession(conversationId);

      return undefined;
    })
    .then(() => {
      return getSessionFromStore(conversationId);
    })
    .then((conversation) => {
      const pubNubChannels = conversation?.attributes?.pubnub?.data?.channels;
      const store = getStore();

      if (!pubNubChannels)
        throw new Error('Conversation PubNub channels not found');

      const conversationChannel = pubNubChannels.find(
        (channel) => channel.type === 'conversation',
      );

      if (store.isPubNubConnected && conversationChannel) {
        const satisfactionMessage = {
          message: {
            eventType: KUSTOMER_APP_CHAT_CSAT_SUBMIT_EVENT,
            data: message.data,
            included: message.included,
          },
          channel: conversationChannel?.name,
        };

        pubnub
          .getMetaPubNub()
          ?.instance?.publish(satisfactionMessage)
          .then((response) => {
            const form = message?.included?.find(
              (entity) => entity.type === 'satisfaction',
            );

            const { timetoken } = response;
            const callbackResponse = createSatisfactionCallbackResponse(
              message.data,
              timetoken,
              form,
            );

            if (typeof cb === 'function') {
              cb(callbackResponse);
            }
          });
      }
    });
};
export const submitSatisfactionForm = (
  parameters: SubmitSatisfactionFormParameters,
  cb?: PublicCallback,
) => {
  const { satisfactionId, rating, submittedAt, answers, lang } = parameters;

  return updateSatisfactionResponse(
    satisfactionId,
    {
      rating,
      answers,
      submittedAt,
    },
    lang,
  )
    .then((res) => {
      return publishSatisfactionSubmitMessage(res, cb);
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      handleError(error, { message: 'Failed to submit satisfaction form' });
    });
};
